module.exports = __webpack_public_path__ + "img/leftArrow.16f00857.png";